{
  "Mon": "poniedziałek",
  "Tue": "wtorek",
  "Wed": "środa",
  "Thu": "czwartek",
  "Fri": "piątek",
  "Sat": "sobota",
  "Sun": "niedziela",
  "CORE": {
    "notificationDateFormat": "d.M.yy",
    "update": "Loading...",
    "youAreOffline": "Device offline! Connect to a network and try again later!",
    "comeBack": "{{icon}} your skis are waiting for you",
    "help": "Pomoc",
    "notification": {
      "ok": "Mam"
    },
    "skiHire": "Wypożyczalnia nart"
  },
  "ALPINSKIHIRE": {
    "AR": {
      "start": {
        "selectBookingParametersFact3": "Zapłać w swojej walucie! Alpy.com pokryje koszt wymiany waluty. Stawki są codziennie aktualizowane.",
        "searchHeadline": "Gdzie chcesz wypożyczyć narty lub deski snowboardowe?"
      },
      "showTownReserveEarlyEnoughInfo": "Prosimy zauważyć, że w sezonie mogą mieć miejsce braki sprzętu w wypożyczalniach. Zalecamy rezerwowanie z wyprzedzeniem.",
      "shop_filter_distance_to_center": "<strong>Odległość</strong> od centrum miasta: <strong><span id='range'>{{ distance }}</span>km</strong>",
      "shopSearch": {
        "formSearchButtonLabel": "SZUKAJ",
        "promocode": {
          "couponCodeIsInCart": "Do koszyka zastosowano kod kuponu {{ code }}, który zostanie uwzględniony na stronie finalizacji zamówienia.",
          "typePromo": "Promocja",
          "typeCoupon": "Kupon"
        }
      }
    },
    "offer": {
      "title": "Dlatego z {{ platformname }}"
    },
    "start": {
      "advantagesHeadline": "Gwarancja najlepszych cen na wynajem nart dzięki rezerwacji online",
      "listedBrands": "Dostępne marki",
      "topTowns": "Najlepsze wypożyczalnie"
    },
    "sidebar": {
      "hotlineItalic": "Pozwól nam sobie pomóc!",
      "callNow": "Zadzwoń teraz na: ",
      "hotline": "Infolinia"
    },
    "shopSearch": {
      "validation": {
        "selectAgeForEveryChild": "Podaj wiek każdego dziecka (wiek na początku okresu wynajmu)",
        "onePersonRequired": "wybierz co najmniej jedną osobę",
        "enterTown": "Wybierz ośrodek narciarski"
      },
      "minified": {
        "users": "Liczba osób dorosłych: {{ number_adults }}, liczba dzieci: {{ number_children }}",
        "date": "{{ start_date }} - {{ end_date }}",
        "dateFormat": "EEEEEE d.M.yy"
      },
      "datePickerDisplayFormat": "EEEEEE d.M.yy",
      "datePickerPreviousMessage": "Możesz odebrać swój sprzęt w wypożyczalni w dniu <span>{{ date }}</span> po godz. 15:30. Bez możliwości nocnej jazdy na nartach.",
      "datePickerPreviousMessageDateFormat": "d.M.yy",
      "formSearchLabel": "Ośrodek, miejscowość, kraj, nazwa wypożyczalni",
      "formSearchInfo": "Chwileczkę, szukamy dopasowań…",
      "formSearchResultDescription": "({{region}}, {{province}})",
      "formSearchResultShopNumber": "Liczba wypożyczalni: {{ count }}",
      "formSearchResultShowAll": "Pokaż wszystkie z {{ count }} wyników",
      "formSearchResultGroupLocations": "Miejscowość",
      "formSearchResultGroupShops": "Shops",
      "formSearchResultGroupRegions": "Region",
      "formSearchResultGroupCountries": "Kraje",
      "formSearchButtonLabelDelivery": "Od {{price}}",
      "deliverToHotel": "Chcę, aby sprzęt został dostarczony do mojego zakwaterowania – ZA DARMO!",
      "formStartDate": "Dzień wynajmu",
      "formEndDate": "Dzień zwrotu",
      "formNumberOfPeople": "Liczba osób",
      "formAdultsLabel": "Osoby dorosłe",
      "formPeopleCount": {
        "numberOfPeople": "{{ number_adults }} {{ pluralizeAdult }} {{ number_children }} {{ pluralizeChildren }}",
        "adultNone": "dorosłych",
        "adultSingle": "dorosłej",
        "adultMultiple": "dorosłych",
        "childNone": "dzieci",
        "childSingle": "dziecka",
        "childMultiple": "dzieci"
      },
      "formAdultsLabelInfo": "powyżej 18. roku życia w momencie rozpoczęcia wynajmu",
      "formChildrenLabel": "Dzieci",
      "formChildrenLabelInfo": "poniżej 18. roku życia w momencie rozpoczęcia wynajmu",
      "formChildInputLabelInfo": "Ile lat ma dziecko? / Ile lat będą mieć dzieci na początku okresu wynajmu?",
      "formChildInputPlaceholder": "ile lat?",
      "formPromotionCode": "Kod promocyjny",
      "formPromotionCodeNotFound": "Ten kod promocyjny nie istnieje.",
      "noResults": "Nie znaleziono wyników"
    },
    "trustpilot": {
      "dateformat": "d/m/yyyy",
      "score": "Wynik zaufania",
      "reviews": "recenzje",
      "reviewsOn": "recenzje na temat"
    },
    "navigation": {
      "skihire": "Wypożyczalnia nart",
      "skischool": "Szkółki narciarskie",
      "accommodation": "Zakwaterowanie",
      "aboutUs": "O nas",
      "helpCenter": "Help Center",
      "subnavBooking": "Rezerwowanie",
      "subnavAdditionalOffers": "Dodatkowe oferty",
      "subnavGroupBooking": "Rezerwacje grupowe",
      "subnavTermsAndConditions": "Warunki",
      "subnavBecomePartner": "Zostań partnerem",
      "subnavPrivacyPolicy": "Polityka prywatności",
      "subnavHelp": "Kontakt",
      "myAlpinresorts": "Moje Alpy.com",
      "subnavLogin": "Zaloguj sie",
      "subnavLogout": "Wyloguj",
      "subnavBookingsAndCancellations": "Rezerwacje i anulacje",
      "subnavPersonalSettings": "Ustawienia osobiste",
      "career": "Kariera",
      "blog": "Blog"
    },
    "geoIp": {
      "chooseACountry": "Wybierz kraj"
    },
    "topCountries": "Najlepsze kraje"
  },
  "ALPINSTATIC": {
    "aboutUs": {
      "title": "O nas",
      "metaDescription": "To tutaj znajdziesz wszystkie informacje dotyczące zespołu {{ productName }}. Zaufaj największej europejskiej sieci outletowych wypożyczalni nart i szkółek narciarskich!"
    },
    "imprint": {
      "title": "Informacje prawne {{ productName }}",
      "metaDescription": "Impressum {{ productName }}"
    },
    "privacy": {
      "title": "Polityka prywatności {{ productName }}",
      "metaDescription": "Polityka prywatności {{ productName }}"
    },
    "termsAndConditions": {
      "title": "Ogólne warunki {{ productName }}",
      "metaDescription": "Ogólne warunki handlowe {{ productName }}"
    },
    "additionalOffers": {
      "title": "Dodatkowe oferty"
    }
  },
  "ROUTES": {
    "CHECKOUT": {
      "PAYMENT": "payment",
      "CHECKOUT": "checkout"
    },
    "CANCELLATION": "anulowac-rezerwacje",
    "SKIHIREENTRY": "wypozyczalnia-nart",
    "COUNTRIES": "kraje",
    "PRODUCTS": "products",
    "PRODUCT": {
      "FINISH": "finish"
    },
    "SKIHIRE": {
      "GROUPS": "groups",
      "PRODUCTS": "products",
      "SEARCH": "wyszukiwanie"
    },
    "SKISCHOOLENTRY": "szkola-narciarska",
    "STATIC": {
      "SWISSPASS": "swisspass",
      "IMPRINT": "impressum",
      "PRIVACYPOLICY": "polityka-prywatnosci",
      "TERMSANDCONDITIONS": "warunki",
      "HELP": "pomoc",
      "ABOUTUS": "o-nas",
      "ADDITIONALOFFERS": "dodatkowe-oferty",
      "HOWTO": "jak-to"
    }
  }
}